import ddt from '@wix/da-ddt';
import { handleActions } from 'redux-actions';
import { pushModal, replaceModal, popModal, removeModal, removeModalsOfType } from './actionCreators';
import { reduxKey } from './constants';
const handler = handleActions({
    [pushModal.toString()]: (state, action)=>{
        if (!action.payload) {
            ddt.warn('modals', 'Modal push without payload');
            return state;
        }
        return [
            ...state,
            action.payload
        ];
    },
    [replaceModal.toString()]: (state, action)=>{
        if (!action.payload) {
            ddt.warn('modals', 'Modal replace without payload');
            return state;
        }
        return [
            ...state.slice(0, -1),
            action.payload
        ];
    },
    [popModal.toString()]: (state, action)=>{
        return state.slice(0, -1);
    },
    [removeModalsOfType.toString()]: (state, action)=>{
        return state.filter((item)=>item.type !== action.payload);
    },
    [removeModal.toString()]: (state, action)=>{
        return state.filter((item)=>item.id !== action.payload);
    }
}, []);
export default {
    [reduxKey]: handler
};
